<template>
  <v-row no-gutters class="pa-2 py-3">
    <v-dialog v-model="cancelDialog" :max-width="500">
      <v-card tile>
        <v-card-title>
          Cancel and Discard {{!getNewQuestion.savedToDatabase ?
          'route' :
          'changes'}}?
        </v-card-title>
        <v-card-text class="pt-2">
          Are you sure you want to cancel this {{!getNewQuestion.savedToDatabase ? 'creation' :
          'edit'}}?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary darken-1" outlined @click.native="cancelDialog = false">No</v-btn>
          <v-btn color="error" depressed @click.native="cancelConfirm">Yes</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-col cols="7">
        <v-text-field outlined dense hide-details placeholder="Description"
                      :label="`Question ID: ${getNewQuestion.qid}`"
                      style="width: 100%; position: relative; float: left"
                      v-model="questionDescription"
                      append-icon="mdi-edit"
                      :rules="[(v) => v.length <= maxDescriptionLength || 'Max ' + maxDescriptionLength + ' characters']"
                      :counter="maxDescriptionLength"
        ></v-text-field>
    </v-col>
    <v-col cols="5" align="end" class="pr-4">
        <div>
          <v-btn height="40" class="ml-2" depressed outlined color="primary" @click="cancelDialog = true">
            Cancel
          </v-btn>
          <v-btn height="40" class="ml-2" depressed :disabled="preventBack" outlined @click="goBack">Back</v-btn>
          <v-btn height="40" class="ml-2" depressed :disabled="computedPreventNext" color="primary" @click="goNext">
            {{nextText}}
          </v-btn>
        </div>
    </v-col>
  </v-row>
</template>

<script>
  import {mapGetters, mapActions, mapMutations} from 'vuex'

  export default {
    name: 'QuestionHeader',

    props: {
      preventNext: {
        type: Boolean,
        default: false
      },
      preventBack: {
        type: Boolean,
        default: false
      }
    },

    computed: {
      ...mapGetters(['getNewQuestion']),
      computedPreventNext () {
        return !!this.getNewQuestion.id || this.preventNext
      },
      nextText() {
        let retText = 'Next';

        if (this.$route.name === 'comments') {
          retText = 'Finish'
        }

        return retText;
      },
      questionDescription: {
        get() {
          return this.getNewQuestion.description;
        },
        set(val) {
          this.UPDATE_QUESTION_DESCRIPTION(val);
        }
      }
    },
    data() {
      return {
        cancelDialog: false,
        routeArray: ['/create/start-point', '/create/end-point', '/create/routes', '/create/comments'],
        maxDescriptionLength: 100
      }
    },
    methods: {
      ...mapMutations(['UPDATE_QUESTION_DESCRIPTION', 'SET_TASK']),
      ...mapActions(['SAVE_QUESTION', 'CANCEL_CREATE', 'LOG_EDIT']),
      cancelConfirm() {
        this.CANCEL_CREATE();
      },
      goBack() {
        this.$router.go(-1)
      },
      goNext() {
        if (this.nextText !== 'Finish') {
          let currRouteIdx = this.routeArray.indexOf(this.$router.currentRoute.fullPath);
          this.$router.push(this.routeArray[currRouteIdx + 1])
        } else {
          this.SAVE_QUESTION(this.getNewQuestion).then(() => {
            this.LOG_EDIT(this.getNewQuestion);
            this.$router.push('/');
            this.SET_TASK('');
          }).catch((error) => {
            this.$confirm({
              title: 'ERROR',
              message: error
            });
          });
        }
      },
    }
  }
</script>

<style>
  .v-banner__content, .v-banner__text {
    width: 100%;
  }

  .text-field-prefix {
    position: relative;
    border-bottom-right-radius: 0px;
    border-top-right-radius: 0px;
  }
</style>
